import styled from 'styled-components';

export const StepBadgeCircle = styled.span.attrs({
  className:
    'flex size-4 shrink-0 items-center justify-center rounded-full bg-vantis-violet text-xs font-medium leading-none text-white',
})``;
